<template>
  <div class="cert-header d-flex py-5">
    <div class="col-9 mx-auto">
      <div class="cert-title cert-large">Resources</div>
    </div>
  </div>
  <div class="col-9 mx-auto mt-5 cert-page-content py-5 px-5">

  </div>
</template>

<script>
export default {
  name: "Resources"
}
</script>

<style scoped>

</style>